import { createI18n } from 'vue-i18n'

// en
import enAdministration from './locales/en/administration.json'
import enAuth from './locales/en/auth.json'
import enCommon from './locales/en/common.json'
import enInvoices from './locales/en/invoices.json'
import enInvoiceForm from './locales/en/invoice_form.json'
import enInvoiceUpload from './locales/en/invoice_upload.json'
import enInvoicePreview from './locales/en/invoice_preview.json'
import enProviders from './locales/en/providers.json'
import enPaymentAgreement from './locales/en/payment_agreement.json'
import enPurchaseOrders from './locales/en/purchase_orders.json'
import enPurchaseOrderPreview from './locales/en/purchase_order_preview.json'
import enQuotations from './locales/en/quotations.json'
import enRequestGroupQuotation from './locales/en/request_group_quotation.json'
import enRequests from './locales/en/requests.json'
import enRenditions from './locales/en/renditions.json'
import enMyInvoices from './locales/en/my_invoices.json'
import enVuetifyExtensions from './locales/en/vuetify-extensions.json'
import enRequestDetails from './locales/en/request_details.json'
import enStepNode from './locales/en/step_node.json'
import enRequestData from './locales/en/request_data.json'
import enPaymentsData from './locales/en/payments_data.json'
import enActionForms from './locales/en/action_forms.json'
import enPayments from './locales/en/payments.json'
import enRequestForm from './locales/en/request_form.json'
import enRequestFormBreakdown from './locales/en/request_form_breakdown.json'
import enRequestAiChat from './locales/en/request_ai_chat.json'
import enCreditCards from './locales/en/credit_cards.json'
import enPaymentForm from './locales/en/payment_form.json'
import enInbox from './locales/en/inbox.json'
import enChileInbox from './locales/en/chile_inbox.json'
import enPeruInbox from './locales/en/peru_inbox.json'
import enMexicoInbox from './locales/en/mexico_inbox.json'
import enColombiaInbox from './locales/en/colombia_inbox.json'
import enSiiSandbox from './locales/en/sii_sandbox.json'
import enContracts from './locales/en/contracts.json'
import enReceptions from './locales/en/receptions.json'
import enBudgets from './locales/en/budgets.json'
import enGeneralInbox from './locales/en/general_inbox.json'
import enTransactions from './locales/en/transactions.json'
import enConciliationForm from './locales/en/conciliation_form.json'
import enTravel from './locales/en/travel.json'
import enProviderFlow from './locales/en/provider_flow.json'
import enFlow from './locales/en/flow.json'
import enCreditNoteForm from './locales/en/credit_note_form.json'
import enCreditNotes from './locales/en/credit_notes.json'
import enInvoiceDuplicates from './locales/en/invoice_duplicates.json'
import enDownloadInvoices from './locales/en/download_invoices.json'
import enInvoiceApprovalForm from './locales/en/invoice_approval_form.json'
import enInvoiceLines from './locales/en/invoice_lines.json'
import enInvoicePOForm from './locales/en/invoice_po_form.json'
import enInvoiceSplitRules from './locales/en/invoice_split_rules.json'
import enBulkInvoiceRequestForm from './locales/en/bulk_invoice_request_form.json'
import enBulkPoDispatch from './locales/en/bulk_po_dispatch.json'
import enInvoiceRequestForm from './locales/en/invoice_request_form.json'
import enLayout from './locales/en/layout.json'
import enApprovalFlow from './locales/en/approval_flow.json'
import enClassification from './locales/en/classification.json'
import enRules from './locales/en/rules.json'
import enInvoiceFirewallFlow from './locales/en/invoice_firewall_flow.json'
import enFirewallResolution from './locales/en/firewall_resolution.json'
import enFirewallNotifications from './locales/en/firewall_notifications.json'
import enRequestGroupActions from './locales/en/request_group_actions.json'
import enProviderTaxIdValidation from './locales/en/provider_tax_id_validation.json'
import enInvoiceCfdiValidation from './locales/en/invoice_cfdi_validation.json'
import enRequestGroupOrders from './locales/en/request_group_orders.json'
import enCreatePaymentForm from './locales/en/create_payment_form.json'
import enBanking from './locales/en/banking.json'
import enBankBatches from './locales/en/bank_batches.json'
import enPaymentComplements from './locales/en/payment_complements.json'
import enIntegrations from './locales/en/integrations.json'
import enTaxRules from './locales/en/tax_rules.json'
import enFintaxRates from './locales/en/fintax_rates.json'
import enPoDispatch from './locales/en/po_dispatch.json'
import enCoverage from './locales/en/coverage.json'
import enRequestGroupAssociations from './locales/en/request_group_associations.json'
import enRestrictiveListValidation from './locales/en/restrictive_list_validation.json'
import enInvoiceBackfill from './locales/en/invoice_backfill.json'
import enInvoicesRework from './locales/en/invoices_rework.json'
import enAiAutofill from './locales/en/ai_autofill.json'
import enRequestGroup from './locales/en/request_group.json'
import enRequestGroupTabs from './locales/en/request_group_tabs.json'
import enRequestGroupComparison from './locales/en/request_group_comparison.json'
import enRequestGroupAccounting from './locales/en/request_group_accounting.json'
import enRequestGroupPayments from './locales/en/request_group_payments.json'
import enRequestGroupEvaluations from './locales/en/request_group_evaluations.json'
import enRequestGroupProviders from './locales/en/request_group_providers.json'
// es
import esInvoices from './locales/es/invoices.json'
import esInvoiceForm from './locales/es/invoice_form.json'
import esInvoiceUpload from './locales/es/invoice_upload.json'
import esInvoicePreview from './locales/es/invoice_preview.json'
import esProviders from './locales/es/providers.json'
import esPaymentAgreement from './locales/es/payment_agreement.json'
import esPurchaseOrders from './locales/es/purchase_orders.json'
import esPurchaseOrderPreview from './locales/es/purchase_order_preview.json'
import esQuotations from './locales/es/quotations.json'
import esRequestGroupQuotation from './locales/es/request_group_quotation.json'
import esRequests from './locales/es/requests.json'
import esRenditions from './locales/es/renditions.json'
import esMyInvoices from './locales/es/my_invoices.json'
import esVuetifyExtensions from './locales/es/vuetify-extensions.json'
import esRequestDetails from './locales/es/request_details.json'
import esStepNode from './locales/es/step_node.json'
import esRequestData from './locales/es/request_data.json'
import esPaymentsData from './locales/es/payments_data.json'
import esActionForms from './locales/es/action_forms.json'
import esPayments from './locales/es/payments.json'
import esRequestForm from './locales/es/request_form.json'
import esRequestFormBreakdown from './locales/es/request_form_breakdown.json'
import esRequestAiChat from './locales/es/request_ai_chat.json'
import esCreditCards from './locales/es/credit_cards.json'
import esPaymentForm from './locales/es/payment_form.json'
import esInbox from './locales/es/inbox.json'
import esChileInbox from './locales/es/chile_inbox.json'
import esPeruInbox from './locales/es/peru_inbox.json'
import esMexicoInbox from './locales/es/mexico_inbox.json'
import esColombiaInbox from './locales/es/colombia_inbox.json'
import esSiiSandbox from './locales/es/sii_sandbox.json'
import esCommon from './locales/es/common.json'
import esAuth from './locales/es/auth.json'
import esAdministration from './locales/es/administration.json'
import esContracts from './locales/es/contracts.json'
import esReceptions from './locales/es/receptions.json'
import esBudgets from './locales/es/budgets.json'
import esGeneralInbox from './locales/es/general_inbox.json'
import esTransactions from './locales/es/transactions.json'
import esConciliationForm from './locales/es/conciliation_form.json'
import esTravel from './locales/es/travel.json'
import esProviderFlow from './locales/es/provider_flow.json'
import esFlow from './locales/es/flow.json'
import esCreditNoteForm from './locales/es/credit_note_form.json'
import esCreditNotes from './locales/es/credit_notes.json'
import esInvoiceDuplicates from './locales/es/invoice_duplicates.json'
import esDownloadInvoices from './locales/es/download_invoices.json'
import esInvoiceApprovalForm from './locales/es/invoice_approval_form.json'
import esInvoiceLines from './locales/es/invoice_lines.json'
import esInvoicePOForm from './locales/es/invoice_po_form.json'
import esInvoiceSplitRules from './locales/es/invoice_split_rules.json'
import esBulkInvoiceRequestForm from './locales/es/bulk_invoice_request_form.json'
import esBulkPoDispatch from './locales/es/bulk_po_dispatch.json'
import esInvoiceRequestForm from './locales/es/invoice_request_form.json'
import esLayout from './locales/es/layout.json'
import esApprovalFlow from './locales/es/approval_flow.json'
import esClassification from './locales/es/classification.json'
import esRules from './locales/es/rules.json'
import esInvoiceFirewallFlow from './locales/es/invoice_firewall_flow.json'
import esFirewallResolution from './locales/es/firewall_resolution.json'
import esFirewallNotifications from './locales/es/firewall_notifications.json'
import esRequestGroupActions from './locales/es/request_group_actions.json'
import esProviderTaxIdValidation from './locales/es/provider_tax_id_validation.json'
import esInvoiceCfdiValidation from './locales/es/invoice_cfdi_validation.json'
import esRequestGroupOrders from './locales/es/request_group_orders.json'
import esCreatePaymentForm from './locales/es/create_payment_form.json'
import esBanking from './locales/es/banking.json'
import esBankBatches from './locales/es/bank_batches.json'
import esPaymentComplements from './locales/es/payment_complements.json'
import esIntegrations from './locales/es/integrations.json'
import esTaxRules from './locales/es/tax_rules.json'
import esFintaxRates from './locales/es/fintax_rates.json'
import esPoDispatch from './locales/es/po_dispatch.json'
import esCoverage from './locales/es/coverage.json'
import esRequestGroupAssociations from './locales/es/request_group_associations.json'
import esRestrictiveListValidation from './locales/es/restrictive_list_validation.json'
import esInvoiceBackfill from './locales/es/invoice_backfill.json'
import esInvoicesRework from './locales/es/invoices_rework.json'
import esAiAutofill from './locales/es/ai_autofill.json'
import esRequestGroup from './locales/es/request_group.json'
import esRequestGroupTabs from './locales/es/request_group_tabs.json'
import esRequestGroupComparison from './locales/es/request_group_comparison.json'
import esRequestGroupAccounting from './locales/es/request_group_accounting.json'
import esRequestGroupPayments from './locales/es/request_group_payments.json'
import esRequestGroupEvaluations from './locales/es/request_group_evaluations.json'
import esRequestGroupProviders from './locales/es/request_group_providers.json'
// pt-BR
import ptBRInvoices from './locales/pt-BR/invoices.json'
import ptBRInvoiceForm from './locales/pt-BR/invoice_form.json'
import ptBRInvoiceUpload from './locales/pt-BR/invoice_upload.json'
import ptBRInvoicePreview from './locales/pt-BR/invoice_preview.json'
import ptBRProviders from './locales/pt-BR/providers.json'
import ptBRPaymentAgreement from './locales/pt-BR/payment_agreement.json'
import ptBRPurchaseOrders from './locales/pt-BR/purchase_orders.json'
import ptBRPurchaseOrderPreview from './locales/pt-BR/purchase_order_preview.json'
import ptBRQuotations from './locales/pt-BR/quotations.json'
import ptBRRequestGroupQuotation from './locales/pt-BR/request_group_quotation.json'
import ptBRRequests from './locales/pt-BR/requests.json'
import ptBRRenditions from './locales/pt-BR/renditions.json'
import ptBRMyInvoices from './locales/pt-BR/my_invoices.json'
import ptBRVuetifyExtensions from './locales/pt-BR/vuetify-extensions.json'
import ptBRRequestDetails from './locales/pt-BR/request_details.json'
import ptBRStepNode from './locales/pt-BR/step_node.json'
import ptBRRequestData from './locales/pt-BR/request_data.json'
import ptBRPaymentsData from './locales/pt-BR/payments_data.json'
import ptBRActionForms from './locales/pt-BR/action_forms.json'
import ptBRPayments from './locales/pt-BR/payments.json'
import ptBRRequestForm from './locales/pt-BR/request_form.json'
import ptBRRequestFormBreakdown from './locales/pt-BR/request_form_breakdown.json'
import ptBRRequestAiChat from './locales/pt-BR/request_ai_chat.json'
import ptBRCreditCards from './locales/pt-BR/credit_cards.json'
import ptBRPaymentForm from './locales/pt-BR/payment_form.json'
import ptBRInbox from './locales/pt-BR/inbox.json'
import ptBRChileInbox from './locales/pt-BR/chile_inbox.json'
import ptBRPeruInbox from './locales/pt-BR/peru_inbox.json'
import ptBRMexicoInbox from './locales/pt-BR/mexico_inbox.json'
import ptBRColombiaInbox from './locales/pt-BR/colombia_inbox.json'
import ptBRSiiSandbox from './locales/pt-BR/sii_sandbox.json'
import ptBRCommon from './locales/pt-BR/common.json'
import ptBRAuth from './locales/pt-BR/auth.json'
import ptBRAdministration from './locales/pt-BR/administration.json'
import ptBRContracts from './locales/pt-BR/contracts.json'
import ptBRReceptions from './locales/pt-BR/receptions.json'
import ptBRBudgets from './locales/pt-BR/budgets.json'
import ptBRGeneralInbox from './locales/pt-BR/general_inbox.json'
import ptBRTransactions from './locales/pt-BR/transactions.json'
import ptBRConciliationForm from './locales/pt-BR/conciliation_form.json'
import ptBRTravel from './locales/pt-BR/travel.json'
import ptBRProviderFlow from './locales/pt-BR/provider_flow.json'
import ptBRFlow from './locales/pt-BR/flow.json'
import ptBRCreditNoteForm from './locales/pt-BR/credit_note_form.json'
import ptBRCreditNotes from './locales/pt-BR/credit_notes.json'
import ptBRInvoiceDuplicates from './locales/pt-BR/invoice_duplicates.json'
import ptBRDownloadInvoices from './locales/pt-BR/download_invoices.json'
import ptBRInvoiceApprovalForm from './locales/pt-BR/invoice_approval_form.json'
import ptBRInvoiceLines from './locales/pt-BR/invoice_lines.json'
import ptBRInvoicePOForm from './locales/pt-BR/invoice_po_form.json'
import ptBRInvoiceSplitRules from './locales/pt-BR/invoice_split_rules.json'
import ptBRBulkInvoiceRequestForm from './locales/pt-BR/bulk_invoice_request_form.json'
import ptBRBulkPoDispatch from './locales/pt-BR/bulk_po_dispatch.json'
import ptBRInvoiceRequestForm from './locales/pt-BR/invoice_request_form.json'
import ptBRLayout from './locales/pt-BR/layout.json'
import ptBRApprovalFlow from './locales/pt-BR/approval_flow.json'
import ptBRClassification from './locales/pt-BR/classification.json'
import ptBRRules from './locales/pt-BR/rules.json'
import ptBRInvoiceFirewallFlow from './locales/pt-BR/invoice_firewall_flow.json'
import ptBRFirewallResolution from './locales/pt-BR/firewall_resolution.json'
import ptBRFirewallNotifications from './locales/pt-BR/firewall_notifications.json'
import ptBRRequestGroupActions from './locales/pt-BR/request_group_actions.json'
import ptBRProviderTaxIdValidation from './locales/pt-BR/provider_tax_id_validation.json'
import ptBRInvoiceCfdiValidation from './locales/pt-BR/invoice_cfdi_validation.json'
import ptBRRequestGroupOrders from './locales/pt-BR/request_group_orders.json'
import ptBRCreatePaymentForm from './locales/pt-BR/create_payment_form.json'
import ptBRBanking from './locales/pt-BR/banking.json'
import ptBRBankBatches from './locales/pt-BR/bank_batches.json'
import ptBRPaymentComplements from './locales/pt-BR/payment_complements.json'
import ptBRIntegrations from './locales/pt-BR/integrations.json'
import ptBRTaxRules from './locales/pt-BR/tax_rules.json'
import ptBRFintaxRates from './locales/pt-BR/fintax_rates.json'
import ptBRPoDispatch from './locales/pt-BR/po_dispatch.json'
import ptBRCoverage from './locales/pt-BR/coverage.json'
import ptBRRequestGroupAssociations from './locales/pt-BR/request_group_associations.json'
import ptBRRestrictiveListValidation from './locales/pt-BR/restrictive_list_validation.json'
import ptBRInvoiceBackfill from './locales/pt-BR/invoice_backfill.json'
import ptBRInvoicesRework from './locales/pt-BR/invoices_rework.json'
import ptBRAiAutofill from './locales/pt-BR/ai_autofill.json'
import ptBRRequestGroup from './locales/pt-BR/request_group.json'
import ptBRRequestGroupTabs from './locales/pt-BR/request_group_tabs.json'
import ptBRRequestGroupComparison from './locales/pt-BR/request_group_comparison.json'
import ptBRRequestGroupAccounting from './locales/pt-BR/request_group_accounting.json'
import ptBRRequestGroupPayments from './locales/pt-BR/request_group_payments.json'
import ptBRRequestGroupEvaluations from './locales/pt-BR/request_group_evaluations.json'
import ptBRRequestGroupProviders from './locales/pt-BR/request_group_providers.json'

const messages = {
  en: {
    common: enCommon,
    auth: enAuth,
    administration: enAdministration,
    purchase_orders: enPurchaseOrders,
    purchase_order_preview: enPurchaseOrderPreview,
    invoices: enInvoices,
    invoice_form: enInvoiceForm,
    invoice_upload: enInvoiceUpload,
    invoice_preview: enInvoicePreview,
    requests: enRequests,
    renditions: enRenditions,
    myInvoices: enMyInvoices,
    providers: enProviders,
    quotations: enQuotations,
    request_group_quotation: enRequestGroupQuotation,
    vuetifyExtensions: enVuetifyExtensions,
    request_details: enRequestDetails,
    step_node: enStepNode,
    request_data: enRequestData,
    payments_data: enPaymentsData,
    action_forms: enActionForms,
    payments: enPayments,
    contracts: enContracts,
    request_form: enRequestForm,
    request_form_breakdown: enRequestFormBreakdown,
    request_ai_chat: enRequestAiChat,
    receptions: enReceptions,
    budgets: enBudgets,
    credit_cards: enCreditCards,
    payment_form: enPaymentForm,
    inbox: enInbox,
    chile_inbox: enChileInbox,
    peru_inbox: enPeruInbox,
    mexico_inbox: enMexicoInbox,
    colombia_inbox: enColombiaInbox,
    sii_sandbox: enSiiSandbox,
    general_inbox: enGeneralInbox,
    transactions: enTransactions,
    conciliation_form: enConciliationForm,
    travel: enTravel,
    providerFlow: enProviderFlow,
    flow: enFlow,
    credit_note_form: enCreditNoteForm,
    credit_notes: enCreditNotes,
    invoice_duplicates: enInvoiceDuplicates,
    download_invoices: enDownloadInvoices,
    invoice_approval_form: enInvoiceApprovalForm,
    invoice_lines: enInvoiceLines,
    invoice_po_form: enInvoicePOForm,
    invoice_split_rules: enInvoiceSplitRules,
    bulk_invoice_request_form: enBulkInvoiceRequestForm,
    bulk_po_dispatch: enBulkPoDispatch,
    invoice_request_form: enInvoiceRequestForm,
    layout: enLayout,
    approval_flow: enApprovalFlow,
    classification: enClassification,
    rules: enRules,
    finn_ops: enInvoiceFirewallFlow,
    finn_ops_resolution: enFirewallResolution,
    firewall_notifications: enFirewallNotifications,
    request_group_actions: enRequestGroupActions,
    provider_tax_id_validation: enProviderTaxIdValidation,
    invoice_cfdi_validation: enInvoiceCfdiValidation,
    request_group_orders: enRequestGroupOrders,
    restrictive_list_validation: enRestrictiveListValidation,
    create_payment_form: enCreatePaymentForm,
    banking: enBanking,
    bank_batches: enBankBatches,
    payment_complements: enPaymentComplements,
    integrations: enIntegrations,
    tax_rules: enTaxRules,
    fintax_rates: enFintaxRates,
    coverage: enCoverage,
    request_group_associations: enRequestGroupAssociations,
    payment_agreement: enPaymentAgreement,
    invoice_backfill: enInvoiceBackfill,
    invoices_rework: enInvoicesRework,
    ai_autofill: enAiAutofill,
    request_group: enRequestGroup,
    request_group_tabs: enRequestGroupTabs,
    request_group_comparison: enRequestGroupComparison,
    request_group_accounting: enRequestGroupAccounting,
    request_group_payments: enRequestGroupPayments,
    request_group_evaluations: enRequestGroupEvaluations,
    request_group_providers: enRequestGroupProviders,
    ...enPoDispatch
  },
  es: {
    common: esCommon,
    auth: esAuth,
    administration: esAdministration,
    purchase_orders: esPurchaseOrders,
    purchase_order_preview: esPurchaseOrderPreview,
    invoices: esInvoices,
    invoice_form: esInvoiceForm,
    invoice_upload: esInvoiceUpload,
    invoice_preview: esInvoicePreview,
    requests: esRequests,
    renditions: esRenditions,
    myInvoices: esMyInvoices,
    providers: esProviders,
    quotations: esQuotations,
    request_group_quotation: esRequestGroupQuotation,
    vuetifyExtensions: esVuetifyExtensions,
    request_details: esRequestDetails,
    step_node: esStepNode,
    request_data: esRequestData,
    payments_data: esPaymentsData,
    action_forms: esActionForms,
    payments: esPayments,
    contracts: esContracts,
    request_form: esRequestForm,
    request_form_breakdown: esRequestFormBreakdown,
    request_ai_chat: esRequestAiChat,
    receptions: esReceptions,
    budgets: esBudgets,
    credit_cards: esCreditCards,
    payment_form: esPaymentForm,
    inbox: esInbox,
    chile_inbox: esChileInbox,
    peru_inbox: esPeruInbox,
    mexico_inbox: esMexicoInbox,
    colombia_inbox: esColombiaInbox,
    sii_sandbox: esSiiSandbox,
    general_inbox: esGeneralInbox,
    transactions: esTransactions,
    conciliation_form: esConciliationForm,
    travel: esTravel,
    providerFlow: esProviderFlow,
    flow: esFlow,
    credit_note_form: esCreditNoteForm,
    credit_notes: esCreditNotes,
    invoice_duplicates: esInvoiceDuplicates,
    download_invoices: esDownloadInvoices,
    invoice_approval_form: esInvoiceApprovalForm,
    invoice_lines: esInvoiceLines,
    invoice_po_form: esInvoicePOForm,
    invoice_split_rules: esInvoiceSplitRules,
    bulk_invoice_request_form: esBulkInvoiceRequestForm,
    bulk_po_dispatch: esBulkPoDispatch,
    invoice_request_form: esInvoiceRequestForm,
    layout: esLayout,
    approval_flow: esApprovalFlow,
    classification: esClassification,
    rules: esRules,
    finn_ops: esInvoiceFirewallFlow,
    finn_ops_resolution: esFirewallResolution,
    firewall_notifications: esFirewallNotifications,
    request_group_actions: esRequestGroupActions,
    provider_tax_id_validation: esProviderTaxIdValidation,
    invoice_cfdi_validation: esInvoiceCfdiValidation,
    request_group_orders: esRequestGroupOrders,
    restrictive_list_validation: esRestrictiveListValidation,
    create_payment_form: esCreatePaymentForm,
    banking: esBanking,
    bank_batches: esBankBatches,
    payment_complements: esPaymentComplements,
    integrations: esIntegrations,
    tax_rules: esTaxRules,
    fintax_rates: esFintaxRates,
    coverage: esCoverage,
    request_group_associations: esRequestGroupAssociations,
    payment_agreement: esPaymentAgreement,
    invoice_backfill: esInvoiceBackfill,
    invoices_rework: esInvoicesRework,
    ai_autofill: esAiAutofill,
    request_group: esRequestGroup,
    request_group_tabs: esRequestGroupTabs,
    request_group_comparison: esRequestGroupComparison,
    request_group_accounting: esRequestGroupAccounting,
    request_group_payments: esRequestGroupPayments,
    request_group_evaluations: esRequestGroupEvaluations,
    request_group_providers: esRequestGroupProviders,
    ...esPoDispatch
  },
  'pt-BR': {
    common: ptBRCommon,
    auth: ptBRAuth,
    administration: ptBRAdministration,
    purchase_orders: ptBRPurchaseOrders,
    purchase_order_preview: ptBRPurchaseOrderPreview,
    invoices: ptBRInvoices,
    invoice_form: ptBRInvoiceForm,
    invoice_upload: ptBRInvoiceUpload,
    invoice_preview: ptBRInvoicePreview,
    requests: ptBRRequests,
    renditions: ptBRRenditions,
    myInvoices: ptBRMyInvoices,
    providers: ptBRProviders,
    quotations: ptBRQuotations,
    request_group_quotation: ptBRRequestGroupQuotation,
    vuetifyExtensions: ptBRVuetifyExtensions,
    request_details: ptBRRequestDetails,
    step_node: ptBRStepNode,
    request_data: ptBRRequestData,
    payments_data: ptBRPaymentsData,
    action_forms: ptBRActionForms,
    payments: ptBRPayments,
    contracts: ptBRContracts,
    request_form: ptBRRequestForm,
    request_form_breakdown: ptBRRequestFormBreakdown,
    request_ai_chat: ptBRRequestAiChat,
    receptions: ptBRReceptions,
    budgets: ptBRBudgets,
    credit_cards: ptBRCreditCards,
    payment_form: ptBRPaymentForm,
    inbox: ptBRInbox,
    chile_inbox: ptBRChileInbox,
    peru_inbox: ptBRPeruInbox,
    mexico_inbox: ptBRMexicoInbox,
    colombia_inbox: ptBRColombiaInbox,
    sii_sandbox: ptBRSiiSandbox,
    general_inbox: ptBRGeneralInbox,
    transactions: ptBRTransactions,
    conciliation_form: ptBRConciliationForm,
    travel: ptBRTravel,
    providerFlow: ptBRProviderFlow,
    flow: ptBRFlow,
    credit_note_form: ptBRCreditNoteForm,
    credit_notes: ptBRCreditNotes,
    invoice_duplicates: ptBRInvoiceDuplicates,
    download_invoices: ptBRDownloadInvoices,
    invoice_approval_form: ptBRInvoiceApprovalForm,
    invoice_lines: ptBRInvoiceLines,
    invoice_po_form: ptBRInvoicePOForm,
    invoice_split_rules: ptBRInvoiceSplitRules,
    bulk_invoice_request_form: ptBRBulkInvoiceRequestForm,
    bulk_po_dispatch: ptBRBulkPoDispatch,
    invoice_request_form: ptBRInvoiceRequestForm,
    layout: ptBRLayout,
    approval_flow: ptBRApprovalFlow,
    classification: ptBRClassification,
    rules: ptBRRules,
    finn_ops: ptBRInvoiceFirewallFlow,
    finn_ops_resolution: ptBRFirewallResolution,
    firewall_notifications: ptBRFirewallNotifications,
    request_group_actions: ptBRRequestGroupActions,
    provider_tax_id_validation: ptBRProviderTaxIdValidation,
    invoice_cfdi_validation: ptBRInvoiceCfdiValidation,
    request_group_orders: ptBRRequestGroupOrders,
    restrictive_list_validation: ptBRRestrictiveListValidation,
    create_payment_form: ptBRCreatePaymentForm,
    banking: ptBRBanking,
    bank_batches: ptBRBankBatches,
    payment_complements: ptBRPaymentComplements,
    integrations: ptBRIntegrations,
    tax_rules: ptBRTaxRules,
    fintax_rates: ptBRFintaxRates,
    coverage: ptBRCoverage,
    request_group_associations: ptBRRequestGroupAssociations,
    payment_agreement: ptBRPaymentAgreement,
    invoice_backfill: ptBRInvoiceBackfill,
    invoices_rework: ptBRInvoicesRework,
    ai_autofill: ptBRAiAutofill,
    request_group: ptBRRequestGroup,
    request_group_tabs: ptBRRequestGroupTabs,
    request_group_comparison: ptBRRequestGroupComparison,
    request_group_accounting: ptBRRequestGroupAccounting,
    request_group_payments: ptBRRequestGroupPayments,
    request_group_evaluations: ptBRRequestGroupEvaluations,
    request_group_providers: ptBRRequestGroupProviders,
    ...ptBRPoDispatch
  }
}

const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem('locale') || 'es', // Default to Spanish
  fallbackLocale: 'en',
  messages,
  // legacy:false → los silent*Warn legacy se ignoran; estas son las que aplican.
  missingWarn: false,
  fallbackWarn: false
})

export default i18n
